import axios from "axios";
export default{
    Objet:[],
    TypeContact:[],
    GetTypeContact(token){
        axios
        .create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                token: token,
            },
        })
        .get("messagerie/get/TypeContact")
        .then((response) => {
            // Succès
            if (response.data) {
                this.TypeContact = response.data;
            }
        })
        .catch(() => {
            console.log("Une erreur s'est générée dans la récupération de la liste des objets.");
        });
    },
    GetListeObjets(token){
        axios
        .create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                token: token,
            },
        })
        .get("messagerie/get/objets")
        .then((response) => {
            // Succès
            if (response.data) {
            this.Objet = response.data;
            }
        })
        .catch(() => {
            console.log("Une erreur s'est générée dans la récupération de la liste des objets.");
        });
    },
    EnvoyerMessage(token, message){
        return axios
        .create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                token: token,
            },
        })
        .post("messagerie/envoyer/message/", message);
    },
    AjoutConversation(token, data){
        return axios
        .create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                token: token,
            },
        })
        .post("messagerie/add/conversation/", data);
    }
}